import { render, staticRenderFns } from "./ModalSectorHeader.vue?vue&type=template&id=cbda2310&scoped=true&"
import script from "./ModalSectorHeader.vue?vue&type=script&lang=js&"
export * from "./ModalSectorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalSectorHeader.vue?vue&type=style&index=0&id=cbda2310&scoped=true&lang=css&"
import style1 from "./ModalSectorHeader.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbda2310",
  null
  
)

export default component.exports